import { MARKETPLACES_ENUM } from '../../../../core';

export const FIELDS = {
    marketplace: 'marketplace',
    name: 'name',
    login: 'login',
    shopCountry: 'shopCountry',
    shopRegion: 'shopRegion',
    shopBaseApiUrl: 'shopBaseApiUrl',
    marketplaceLastSync: 'marketplaceLastSync',
    marketplaceMessagesLastSync: 'marketplaceMessagesLastSync',
    marketplaceOrdersLastSync: 'marketplaceOrdersLastSync',
    restrictBlock: 'restrictBlock',
    receiveBlockNotification: 'receiveBlockNotification',
    smtpSettings: 'smtpSettings',
    isExceededLimitBlocked: 'isExceededLimitBlocked'
};

export const SMTP_FIELDS = {
    password: 'password',
    smtpServer: 'smtpserver',
    smtpPort: 'smtpport',
    smtpUseSsl: 'smtpuseSsl',
    protocolType: 'protocolType',
    protocolAddress: 'protocolAddress',
    protocolPort: 'protocolPort',
    protocolUseSsl: 'protocolUseSSL'
};

export const MARKETPLACES_WITH_SHOP_URL = [
    MARKETPLACES_ENUM.BigCommerce,
    MARKETPLACES_ENUM.Shopify,
    MARKETPLACES_ENUM.WooCommerce,
    MARKETPLACES_ENUM.Magento
];

export const TABS = {
    general: 'general',
    smtp: 'smtp',
    administration: 'administration',
    logs: 'logs'
};

export const TAB_FIELDS = {
    [TABS.general]: [
        FIELDS.name,
        FIELDS.login,
        FIELDS.shopCountry,
        FIELDS.shopRegion,
        FIELDS.shopBaseApiUrl,
        FIELDS.marketplaceMessagesLastSync,
        FIELDS.marketplaceOrdersLastSync
    ],
    [TABS.smtp]: Object.values(SMTP_FIELDS),
    [TABS.administration]: [
        FIELDS.restrictBlock,
        FIELDS.receiveBlockNotification
    ]
};

export const MODAL_WIDTH = 700;
export const COPY_FEEDBACK_DURATION = 2000;
